var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/timeline_settings.tsx";
import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import { changeSetting } from 'soapbox/actions/settings';
import SettingToggle from 'soapbox/features/notifications/components/setting_toggle';
import { useSettings } from 'soapbox/hooks';
import List, { ListItem } from './list';
function TimelineSettings({
  timeline,
  onClose,
  className = ''
}) {
  const settings = useSettings();
  const dispatch = useDispatch();
  const onChange = useCallback((key, checked) => {
    dispatch(changeSetting(key, checked));
  }, [dispatch]);
  return /*#__PURE__*/React.createElement(List, {
    className: className,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(ListItem, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "home.column_settings.show_replies",
      defaultMessage: "Show replies",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 28,
        columnNumber: 16
      }
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(SettingToggle, {
    settings: settings,
    settingPath: [timeline, 'shows', 'reply'],
    onChange: onChange,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 30,
      columnNumber: 9
    }
  })), /*#__PURE__*/React.createElement(ListItem, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "home.column_settings.only_media",
      defaultMessage: "Show only media",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 33,
        columnNumber: 16
      }
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 32,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(SettingToggle, {
    settings: settings,
    settingPath: [timeline, 'other', 'onlyMedia'],
    onChange: onChange,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 35,
      columnNumber: 9
    }
  })));
}
export default TimelineSettings;